import React from "react";

import styles from "./YoutubeEmbed.mscss";

export const YoutubeEmbed = ({ className, width, height, src }) => {
    return (
        <div className={styles.YoutubeEmbed}>
            <iframe
                {...({ loading: "lazy" } as any)}
                width={width}
                height={height}
                src={src}
                frameBorder="0"
                allowFullScreen
                className={className}
            />
        </div>
    );
};
